import {Injectable} from '@angular/core';
import {AbstractService} from './service.abstract';
import {Http} from '@angular/http';
import {GlobalQuery} from '../core/global_query';
import {GlobalValidateModel} from '../core/global_validate';
import {Global_DB} from '../core/global_db';
import {GlobalFunction} from '../core/global_function';
import {API} from '../../config/api';
import 'rxjs/add/operator/toPromise';

declare var $: any;
@Injectable()
export class ServiceGlobal extends AbstractService {
    id: any;
    created_at: string;
    updated_at: string;
    updater_id: Number;
    creator_id: Number;
    createddate: Number;
    lastmoddate: Number;
    created_by: string;
    keyword: any;
    modified_by: string;
    _scenario: string;
    _validate: GlobalValidateModel;
    _query: GlobalQuery;
    _error_api: any = {};
    _old_attributes: any = {};
    _attr_submit: any = {};
    created_time: any;
    modified_time: any;
    academic_year: string = null;

    api_find_all: any = '';
    name_alpha: any = '';
    primary_key: any = 'id';
    api_delete: any= '';
    dbname() {
        return 'profilefacebook';
    }
    table_search_attribute: any = {};
    constructor(public _db: Global_DB, public http: Http) {
        super();
        this._db.dbname = this.dbname();
        this._validate = new GlobalValidateModel(this);
        this._query = new GlobalQuery(this, this._db);
        for (var i in this.attributeLabels()) {
            this.table_search_attribute[i] = [];
        }
    }
    set scenario(value: string) { this._scenario = value; }
    get scenario() { return this._scenario; }
    tableName() { return ''; }
    rule() {
        return {
            id: {
                type: 'int',
            },
            "keyword":  {
                "type":"any",
                'search': true
            },
            "academic_year": {
                "type": "string",
                "size": 255,
                'search': true,
            },
            "alpha": {
                "type": "string",
                "search": {
                    op: 'like',
                    value: '{value}%',
                },
            },
            created_at: {
                type: 'int',
            },
            updated_at: {
                type: 'int',
            },
            updater_id: {
                type: 'int',
            },
            creator_id: {
                type: 'int',
            },
            createddate: {
                type: 'int',
            },
            lastmoddate: {
                type: 'int',
            },
            created_by: {
                type: 'int',
            },
            modified_by: {
                type: 'int',
            }
        };
    }
    fk_table_attribute: any = [];
    attr_validate: any = {};
    attr_not_save = ['id', 'created_at', 'updated_at', 'updater_id', 'creator_id', 'ip', 'lang'];
    attributeLabels() {
        return {
            id: 'Id',
            "keyword": "keyword",
            created_at: 'Create time',
            updated_at: 'Update time',
            updater_id: 'Update id',
            creator_id: 'Create id',
            createddate: 'Create date',
            lastmoddate: 'Update date',
            alpha: "Alpha",
            "academic_year": "Academic Year",
            created_by: 'Create by',
            modified_by: 'Update by'
        };
    }

    attributeNotGet() {
        var obj_not_get = ['created_at', 'updated_at', 'updater_id', 'creator_id'];
        var list = this.attributeLabels();
        var rs = {};
        for (var i in list) {
            if (!GlobalFunction.contains(i, obj_not_get)) {
                rs[i] = list[i];
            }
        }
        return rs;
    }

    cloneTo(objToClone) {
        if (objToClone) {
            for (var attr in this) {
                objToClone[attr] = this[attr];
            }
        }
    }

    resetAttributes() {
        let attr = this.attributeLabels();
        for (let i in attr) {
            this[i] = undefined;
        }
        for (let i in this.table_search_attribute) {
            for (let j in this.table_search_attribute[i]) {
                if (this.table_search_attribute[i][j] && this.table_search_attribute[i][j]['value']) {
                    this.table_search_attribute[i][j]['value'] = undefined;
                }
            }
        }
    }

    resetAttributesNotFk() {
        let attr = this.attributeLabels();
        for (let i in attr) {
            if (!i.match(/^fk_table_/gi)) {
                this[i] = undefined;
            }
        }
    }

    resetAttribute(attr: any) {
        if (this.hasAttribute(attr)) {
            this[attr] = undefined;
        }
    }

    hasAttribute(attr: string) {
        return this.attributeLabels()[attr] ? true : false;
    }

    getAttributes() {
        let attr = this.attributeLabels();
        let rs = {};
        for (let i in attr) {
            if (this[i] !== undefined) {
                if (i.match(/^list_/gi)) {
                    var array_item = [];
                    if (this[i].length) {
                        for (var item of this[i]) {
                            if (typeof (item) == 'object' && typeof (item.getAttributes) == 'function') {
                                array_item.push(item.getAttributes());
                            } else {
                                array_item.push(item);
                            }
                        }
                    }
                    rs[i] = array_item;
                } else {
                    rs[i] = this[i];
                }
            }
        }
        return rs;
    }

    getAttributesNotEmpty() {
        let attr = this.attributeLabels();
        let rs = {};
        for (let i in attr) {
            if (this[i] && !i.match(/^fk_table_/gi)) {
                rs[i] = this[i];
            }
        }
        return rs;
    }

    setAttributesNotEmpty(rs) {
        Object.assign(this, rs);
        return true;
    }
    setAttributesNotEmptyThen(rs) {
        var that = this;
        return GlobalFunction.setTimeout(1).then(function () {
            that.setAttributesNotEmpty(rs);
            that.setAttributesSearch(rs);
            return Promise.resolve(true);
        })
    }
    showAttribuesSearch(i, j) {
        var that = this;
        function get_value(item) {
            if (item) {
                if (GlobalFunction.is_array(item.value)) {
                    var a = [];
                    for (var item_child of item.value) {
                        var v = that.showAttribute(i, item_child);
                        if (that.get_type(i, item_child) == 'datetime') {
                            v = v.replace(/ [0-9]{2}\:00$/, '');
                        }
                        a.push(v);
                    }
                    return a.join(', ');
                } else {
                    var v = that.showAttribute(i, item.value);
                    if (that.get_type(i, item.value) == 'datetime') {
                        v = v.replace(/ [0-9]{2}\:00$/, '');
                    }
                    return v;
                }
            }
            return "";
        }
        var vl = '';
        if (j !== undefined) {
            vl = get_value(this.table_search_attribute[i][j]);
        } else {
            var a = [];
            for (var item of this.table_search_attribute[i]) {
                a.push(get_value(item));
            }
            vl = a.join(', ');
        }
        return vl;
    }
    showAttribuesByValue(attr, value) {
        if (value) {
            value = value.replace(/\|/gi, '');
            if (value.match(/,/gi)) {
                value = value.split(',');
            }
            if (GlobalFunction.is_array(value)) {
                var a = [];
                for (var item of value) {
                    a.push(this.showAttribute(attr, item));
                }
                return a.join(', ');
            } else {
                return this.showAttribute(attr, value);
            }
        }
        return "";
    }

    setAttributeSearchByAttributes(rs) {
        for (var i in rs) {
            if (rs[i]) {
                var value = decodeURIComponent(rs[i]);
                var array_value = value.split('||');
                for (var j in array_value) {
                    var array_vl: any = array_value[j].split('|');
                    array_vl[0] = typeof (array_vl[0]) == 'string' && array_vl[0].match(/,/gi) ? array_vl[0].split(',') : array_vl[0];
                    if (array_vl.length == 3) {
                        this.table_search_attribute[i][array_vl[2]] = { value: array_vl[0], operator: array_vl[1] };
                    } else if (array_vl.length == 2) {
                        this.table_search_attribute[i][j] = { value: array_vl[0], operator: array_vl[1] };
                    } else {
                        this.table_search_attribute[i][j] = { value: array_vl[0] };
                    }
                }
            } else {
                for (let j in this.table_search_attribute[i]) {
                    if (this.table_search_attribute[i][j] && this.table_search_attribute[i][j]['value']) {
                        this.table_search_attribute[i][j]['value'] = undefined;
                    }
                }
            }
        }
    }

    setAttributesSearch(rs) {
        for (let i in this.table_search_attribute) {
            if (rs[i]) {
                var value = decodeURIComponent(rs[i]);
                var array_value = value.split('||');
                for (var j in array_value) {
                    var array_vl: any = array_value[j].split('|');
                    array_vl[0] = typeof (array_vl[0]) == 'string' && array_vl[0].match(/,/gi) ? array_vl[0].split(',') : array_vl[0];
                    if (array_vl.length == 3) {
                        this.table_search_attribute[i][array_vl[2]] = { value: array_vl[0], operator: array_vl[1] };
                    } else if (array_vl.length == 2) {
                        this.table_search_attribute[i][j] = { value: array_vl[0], operator: array_vl[1] };
                    } else {
                        this.table_search_attribute[i][j] = { value: array_vl[0] };
                    }
                }
            } else {
                for (let j in this.table_search_attribute[i]) {
                    if (this.table_search_attribute[i][j] && this.table_search_attribute[i][j]['value']) {
                        this.table_search_attribute[i][j]['value'] = undefined;
                    }
                }
            }
        }
    }
    getValueSearch(k, vl) {
        var rs = vl;
        switch (typeof (vl)) {
            case 'object':
                if (GlobalFunction.is_array(vl)) {
                    rs = vl.join(',');
                } else {
                    rs = GlobalFunction.formatDateTime(vl, 'y-m-d');
                }

                break;
        }
        return rs;
    }
    getAttributesSearch(k: any = undefined) {
        var that = this;
        function get_attr_value(i) {
            var item = [];
            for (var j in that.table_search_attribute[i]) {
                var vl = that.getValueSearch(i, that.table_search_attribute[i][j]['value']);
                if (vl) {
                    if (that.table_search_attribute[i][j]['operator']) {
                        vl += '|' + that.table_search_attribute[i][j]['operator'];
                        vl += '|' + j;
                    }
                    item.push(vl);
                }
            }
            return item.join("||");
        }
        var rs: any;
        if (k === undefined) {
            rs = {};
            for (var i in this.table_search_attribute) {
                var item: any = get_attr_value(i);
                if (item.length) {
                    rs[i] = item;
                }
            }
        } else {
            rs = get_attr_value(k);
        }
        return rs;
    }
    showAttributes() {
        let attr = this.attributeLabels();
        let rs = {};
        for (let i in attr) {
            if (this[i] !== undefined) {
                rs[i] = this.showAttribute(i, this[i]);
            }
        }
        return rs;
    }
    showAttribute(attr: string, value: any, rs: any = false) {
        if (this['show_' + attr]) {
            return this['show_' + attr](attr, value);
        }
        var rule = this.rule()[attr];
        var type = rule ? rule['type'] : '';

        if (rule && rule['fk']) {
            if (attr.match(/_mul$/gi) && value && value !== undefined) {
                if (typeof (value) == 'string') {
                    value = value.split(',');
                } else if (typeof (value) == 'number') {
                    value = [value];
                }
                var a = [];
                for (var i in value) {
                    if (this['fk_table_' + attr + '_obj'] && this['fk_table_' + attr + '_obj'][value[i]]) {
                        a.push(this['fk_table_' + attr + '_obj'][value[i]]);
                    }
                }
                return a.join(', ');
            }
            if (rule['attr_ref']) {
                return this['fk_table_' + rule['attr_ref'] + '_obj'] && this['fk_table_' + rule['attr_ref'] + '_obj'][value] ? this['fk_table_' + rule['attr_ref'] + '_obj'][value] : '';

            }
            return this['fk_table_' + attr + '_obj'] && this['fk_table_' + attr + '_obj'][value] ? this['fk_table_' + attr + '_obj'][value] : '';

        }
        if (attr.match(/image|file|avartar/gi)) {
            if (value !== undefined && value && typeof (value) == 'string') {
                if (value.match(/^\[(\{|\])/gi)) {
                    value = JSON.parse(value);
                    for (var i in value) {
                        value[i]['link'] = this.get_link_file(value[i]['name']);
                    }
                } else {
                    value = this.get_link_file(value);
                }
            }
        } else {
            if (GlobalFunction.contains(type, ['int', 'bigint'])) {
                if (GlobalFunction.contains(attr, ['lastmoddate', 'createddate'])) {
                    var v = GlobalFunction.formatDateTime(value);
                    return v;
                } else {
                    if (value !== undefined && value) {
                        if (typeof (value) == 'string' && value.trim().match(/^[0-9]+$/gi)) {
                            return parseInt(value);
                        } else {
                            return value;
                        }
                    } else {
                        return '';
                    }
                }
            } else if (GlobalFunction.contains(type, ['float', 'double'])) {
                return value !== undefined ? parseFloat(value) : '';
            } else if (GlobalFunction.contains(type, ['string', 'varchar', 'longtext', 'text'])) {
                return value;
            } else if (GlobalFunction.contains(type, ['date', 'datetime'])) {
                return GlobalFunction.formatDateTime(value, type == 'datetime' ? 'd-t-y h:i' : 'd-t-y');
            }
        }
        return value;
    }

    get_type(attr, value) {
        var rule = this.rule()[attr];
        var type = rule ? rule['type'] : '';
        if (rule && rule['fk']) {
            if (attr.match(/_mul$/gi)) {
                return 'array';
            } else {
                return type;
            }
        }
        if (attr.match(/image|file|avartar/gi)) {
            if (value !== undefined && value && typeof (value) == 'string') {
                if (value.match(/^\[(\{|\])/gi)) {
                    return 'object';
                } else {
                    return 'string';
                }
            }
        } else {
            if (GlobalFunction.contains(type, ['int', 'bigint'])) {
                if (GlobalFunction.contains(attr, ['lastmoddate', 'createddate'])) {
                    return 'datetime';
                }
            } else if (GlobalFunction.contains(type, ['string', 'varchar', 'longtext', 'text'])) {
                return 'string';
            }
        }
        return type;
    }

    get_link_file(file_name) {
        return "";
    }

    setAttribute(attr: string, value: any): boolean {
        function get_value(vl) {
            if (vl && vl !== undefined && typeof (vl) == 'object') {
                if (GlobalFunction.is_array(vl)) {
                    var a = [];
                    for (var item of vl) {
                        a.push(get_value(item));
                    }
                    vl = a;
                } else {
                    vl = Object.assign({}, vl);
                }
            }
            return vl;
        }
        if (this.hasAttribute(attr)) {
            if (value !== undefined && value !== null) {
                var type = this.rule()[attr] ? this.rule()[attr]['type'] : '';
                if (GlobalFunction.contains(type, ['int', 'bigint'])) {
                    // value = parseInt(value);
                } else if (GlobalFunction.contains(type, ['float', 'double'])) {
                    // value = parseFloat(value);
                } else if (GlobalFunction.contains(type, ['string', 'varchar', 'longtext', 'text'])) {
                    // value = '' + value;
                } else if (GlobalFunction.contains(type, ['date', 'datetime'])) {
                    // value = GlobalFunction.newDate(value);
                }
            }

            this[attr] = get_value(value);
            return true;
        } else {
            this[attr] = value;
        }
        return false;
    }


    setAttributes(rs) {
        for (let i in rs) {
            this.setAttribute(i, rs[i]);
            if (i.match(/^fk_table_/gi)) {
                if (GlobalFunction.is_array(rs[i])) {
                    this[i + '_obj'] = GlobalFunction.indexObj(rs[i], 'id', 'text');
                }
            }
        }
    }

    setAttributesAndOldAttributes(rs) {
        this.setAttributes(rs);
        this._old_attributes = rs;
    }

    delete_attr_create(a) {
        delete a['id'];
        delete a['createddate'];
        delete a['lastmoddate'];
        delete a['created_by'];
        delete a['modified_by'];
    }

    getAttributesInsert() {
        let attr = this.attributeLabels();
        let rs = {};
        for (let i in attr) {
            if (!i.match(/^fk_table/gi) && !GlobalFunction.contains(i, this.attr_not_save) && this[i] !== undefined) {
                if (i.match(/^list_/gi)) {
                    var array_item = { 'create': [] };
                    if (this[i].length) {
                        for (var item of this[i]) {
                            var a;
                            if (typeof (item) == 'object' && typeof (item.getAttributes) == 'function') {
                                a = item.getAttributes();
                            } else {
                                a = Object.assign({}, item);
                            }
                            this.delete_attr_create(a);
                            array_item['create'].push(a);
                        }
                    }
                    if (array_item['create'].length) {
                        rs[i] = array_item;
                    }
                } else {
                    rs[i] = this[i];
                }
            }
        }
        return rs;
    }
    getAttributesUpdate() {
        var attributes = {};
        for (let i in this.attributeLabels()) {
            if (this[i] !== undefined) {
                attributes[i] = this[i];
            }
        }
        var attributes_update = {};
        var attr: any;
        for (var k in attributes) {
            if (k.match(/^list_/gi)) {
                // console.log(k, attributes[k]);
                var array_item = { 'delete': [], 'create': [], 'update': [] };
                if ((!this._old_attributes[k] || this._old_attributes[k] === undefined || !this._old_attributes[k].length)) {
                    if (attributes[k]) {
                        for (let item of attributes[k]) {
                            if (typeof (item) == 'object' && typeof (item.getAttributes) == 'function') {
                                attr = item.isNewRecord() ? item.getAttributesInsert() : item.getAttributesUpdate();
                            } else {
                                attr = Object.assign({}, item);
                            }
                            this.delete_attr_create(attr);
                            array_item['create'].push(attr);
                        }
                    }
                } else {
                    if (!attributes[k] || attributes[k] === undefined || !attributes[k].length) {
                        for (let item of this._old_attributes[k]) {
                            array_item['delete'].push(item['id']);
                        }
                    } else {
                        for (let item_old of this._old_attributes[k]) {
                            var type = 'delete';
                            for (let item_new of attributes[k]) {
                                if (item_old.id == item_new.id) {
                                    type = 'update';
                                    if (typeof (item_new) == 'object' && typeof (item_new.getAttributes) == 'function') {
                                        var attr = item_new.getAttributesUpdate();
                                        if (Object.keys(attr).length) {
                                            array_item['update'].push(Object.assign({ id: item_new.id }, attr));
                                        }
                                    } else {
                                        if (JSON.stringify(item_old) != JSON.stringify(item_new)) {
                                            array_item['update'].push(item_new);
                                        }
                                    }
                                }
                            }
                            if (type == 'delete') {
                                array_item['delete'].push(item_old.id);
                            }
                        }
                        for (let item_new of attributes[k]) {
                            var type = 'create';
                            for (let item_old of this._old_attributes[k]) {
                                if (item_old.id == item_new.id) {
                                    type = 'update';
                                }
                            }
                            if (type == 'create') {
                                if (typeof (item_new) == 'object' && typeof (item_new.getAttributes) == 'function') {
                                    attr = item_new.getAttributesInsert();
                                } else {
                                    attr = Object.assign({}, item_new);
                                }
                                this.delete_attr_create(attr);
                                array_item['create'].push(attr);
                            }
                        }
                    }
                }
                if (array_item['create'].length || array_item['update'].length || array_item['delete'].length) {
                    attributes_update[k] = array_item;
                }
            } else {
                if (!k.match(/^fk_table/gi) && this._old_attributes[k] != attributes[k] && !GlobalFunction.contains(k, ['createddate', 'lastmoddate', 'created_by', 'modified_by'])) {
                    attributes_update[k] = attributes[k];
                }
            }
        }
        return attributes_update;
    }

    validate() {
        var rs = this._validate.validate();
        return rs;
    }

    find(): GlobalQuery {
        return this._query;
    }

    async delete(id = false) {
        if (!id && this[this.primary_key]) {
            id = this[this.primary_key];
        }
        if (id && this.api_delete) {
            let api = API.API_URL_COMMON + this.api_delete + '/' + id;
            return this._db.delete(api);
        } else {
            return Promise.resolve(false);
        }

    }
    async deleteAll(condition: any, params: any = false) {
        return this._db.post(API.DELETEALL, {
            table_name: this.tableName(),
            where: condition,
            params: params,
        });
    }

    async save(valid: boolean = true) {
        if (!valid || this.validate()) {
            return this.id ? this.update() : this.insert();
        } else {
            return Promise.resolve({
                code: 400,
                attributes: this._validate.getErrors(),
            });
        }
    }

    async validate_attributes(attributes) {
        if (GlobalFunction.is_array(attributes)) {
            var a = {};
            for (var item of attributes) {
                a[item] = true;
            }
            attributes = a;
        }
        return this._validate.validate(attributes);
    }

    async insert() {
        var attributes = this.getAttributesInsert();
        return this._db.post(API.API_URL_COMMON + this.api_find_one + '?$top=1', attributes).then(res => {
            if (res.code == 200) {
                this.setAttributesAndOldAttributes(res.attributes);
            } else {
                this._error_api = res.error;
            }
            return Promise.resolve(res);
        });
    }
    async update() {
        var attributes = this.getAttributesUpdate();
        if (attributes && Object.keys(attributes).length) {
            return this._db.post(API.API_URL_COMMON + this.api_find_one + '/' + attributes[this.primary_key], attributes).then(res => {
                if (res.code == 200) {
                    this.setAttributesAndOldAttributes(res.attributes);
                } else {
                    this._error_api = res.error;
                }
                return Promise.resolve(res);
            });
        } else {
            return Promise.resolve({ code: 200, attributes: this.getAttributes() });
        }
    }
    async findOne(id: any, condition: any = {}) {
        // if (!this.id) {
        this.id = id;
        // }
        condition = Object.assign({
            table_name: this.tableName(),
            id: this.id
        }, condition);
        return this.id ? this._db.get(API.VIEW, condition).then(rs => {
            if (rs) {
                this.setAttributes(rs);
                this._old_attributes = rs;
                return Promise.resolve(true);
            } else {
                return Promise.resolve(false);
            }
        }) : Promise.resolve(false);
    }
    findAll(condition: any = {}, limit: number = 0, offset: number = 0) {
        var that = this;
        if(limit) {
            condition['$top'] = limit;
        }
        if(offset) {
            condition['$skip'] = offset;
        }
        return this._db.get(API.API_URL_COMMON + this.api_find_all, condition).then(rs => {
            if(rs) {
                for(var item of rs) {
                    item.alpha = (item[that.name_alpha] && item[that.name_alpha][0]) ? item[that.name_alpha][0].toLowerCase() : '';
                    item.id = item[that.primary_key];
                }
                return rs;
            }
        })
    }

    api_find_one: any;

    async findOneData(id: any, condition: any = {}) {
        var that = this;
        return this._db.get(API.API_URL_COMMON + this.api_find_one +'/'+ id, condition).then(rs => {
            for(var k in rs) {
                that[k] = rs[k];
            }
            return rs;
        })
    }

    async findOneDataPrefix(id: any, prefix: any, condition: any = {}) {
      return this._db.get(API.API_URL_COMMON + this.api_find_one + '/' + id + prefix, condition).then(rs => {
        return rs;
      });
    }
    async getTrackingChartData(id: any, prefix: any, condition: any = {}) {
      return this._db.get(API.API_URL_COMMON + this.api_find_one + '/?' + prefix +'='+ id, condition).then(rs => {
        return rs;
      });
    }
    async refreshIndex() {
      return this._db.post(API.API_URL_COMMON + 'refresh_report_table').then(res => {
            if (res && res.error) {
                this._error_api = res.error;
            }
            return res;
      });
    }

    isNewRecord() {
        return this.id && this.id !== undefined ? false : true;
    }

    isUpdateAttribute(attr) {
        var _old_attributes = this._old_attributes;
        if (this[attr] && this[attr] != _old_attributes[attr]) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/service.global.ts